import { render, staticRenderFns } from "./AddPackage.vue?vue&type=template&id=3ccc6f9d&scoped=true"
import script from "./AddPackage.vue?vue&type=script&lang=js"
export * from "./AddPackage.vue?vue&type=script&lang=js"
import style0 from "./AddPackage.vue?vue&type=style&index=0&id=3ccc6f9d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ccc6f9d",
  null
  
)

export default component.exports